import { render, staticRenderFns } from "./MenuLeftAdmin.vue?vue&type=template&id=12aaf70e&scoped=true&"
import script from "./MenuLeftAdmin.vue?vue&type=script&lang=ts&"
export * from "./MenuLeftAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./MenuLeftAdmin.vue?vue&type=style&index=0&id=12aaf70e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12aaf70e",
  null
  
)

export default component.exports